<template>
    <v-container class="overflow-y-auto grey lighten-5 participacao-resultado-container" fluid>
        <my-upload 
            field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="uploadShow"
            :width="300"
            :height="300"
            :params="uploadParams"
            :headers="uploadHeaders"
            img-format="png"
            langType="pt-br"
            :noSquare="true">
        </my-upload>
        <!-- OVERLAY DE CONQUISTAS -->
        <v-overlay v-if="notificarConquista != null" :value="true">
            <v-container fluid fill-height style="width:900px; height:800px;background: url('/upload/sou_mais/bg_party.png') center center; background-repeat: no-repeat; background-size: contain;">
                <v-row align="center" justify="center">
                    <v-col align-self="center">
                        <v-card max-width="600" max-height="500" style="margin: 0px 20%;" rounded color="white">
                            <v-card-text>
                                <div class="display-3" style="width:100%;text-align: center;">
                                    <v-avatar size="100">
                                        <v-img :src="`data:image/png;base64,${notificarConquista.Conquista.Icone.base64}`"></v-img>
                                    </v-avatar><br />
                                    <strong style='color:#1FA9E1;font-size:50px;'>Sensacional!</strong>
                                    <div style="font-size:18px; line-height:30px; color:black;" v-html="notificarConquista.Conquista.DesbloqueioDescricao"></div>   
                                    <v-btn @click="marcarConquistaNotificada(notificarConquista.Id)" color="primary" width="130" rounded>OK</v-btn>                                                                  
                                </div>                      
                            </v-card-text>
                        </v-card>                        
                    </v-col>
                </v-row>
            </v-container>
        </v-overlay>
        <!-- DIALOG GENERICO url="/upload/sou_mais/"-->
        <v-dialog v-model="dialogDinamico.mostrar" :width="dialogDinamico.width" style="height:300px;" :persistent="dialogDinamico.persistir" rounded align-self-center>
            <v-card class="rounded-xl" rounded align-self-center>
                <v-card-title style="word-break: break-word !important;">
                    <v-flex v-html="dialogDinamico.titulo"></v-flex>
                </v-card-title>
                <v-card-subtitle>
                    <v-flex v-html="dialogDinamico.subTitulo"></v-flex>
                </v-card-subtitle>
                <v-card-text class="text-center overflow-y-auto">
                    <v-flex v-if="dialogDinamico.campanhaRegra">
                        <v-carousel v-model="campanhaRegraCarousel" :continuous="false" :hide-delimiter-background="true" :show-arrows-on-hover="false" delimiter-icon="mdi-circle" prev-icon="mdi-arrow-left" next-icon="mdi-arrow-right" style="height:430px;">
                            <v-carousel-item v-for="(item, i) in campanhaRegraLista" :key="i">
                                <v-sheet color="white">
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <img style="padding:0px;" :src="`/upload/sou_mais/${item.imagem}`" :width="item.imagemWidth" :height="item.imagemHeight" /><br />
                                        </v-col>                              
                                    </v-row>  
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="9">                                        
                                            <strong style='color:#1FA9E1;font-size:50px;'>{{ item.titulo }}</strong><br />
                                            <div style="font-size:18px; line-height:30px; color:black;" v-html="item.texto"></div>                                            
                                        </v-col>                                        
                                    </v-row>
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <v-btn v-if="item.acao" @click="regulamentoDialog()" color="#1FA9E1" rounded large outlined><strong style="font-size:18px;">Clique aqui para acessar</strong></v-btn>
                                            <v-btn v-if="item.ultimo" @click="marcarCampanhaRegraLida()" color="#1FA9E1" rounded large outlined><strong style="font-size:18px;">Continuar</strong></v-btn>   
                                        </v-col>                                        
                                    </v-row>                                                                        
                                </v-sheet>                                                               
                            </v-carousel-item>
                        </v-carousel>
                    </v-flex>
                    <v-flex v-if="dialogDinamico.conteudoDinamico" v-html="dialogDinamico.conteudo"></v-flex>
                    <v-flex v-if="dialogDinamico.campanhaInfo">
                        <v-row dense v-for="(item, i) in campanhaInfo" :key="i"  style="padding:4px 0px;">
                            <v-col cols="2" align-self-center>
                                <v-icon v-text="item.icone" color="#1FA9E1"> </v-icon>
                            </v-col>
                            <v-col cols="10" style="text-align:justify;">
                                <v-flex v-html="item.texto"></v-flex>
                            </v-col>                                    
                        </v-row>                        
                    </v-flex>
                    <v-flex v-if="dialogDinamico.videoInfo">
                        <iframe width="100%" height="400" src="https://www.youtube.com/embed/isT0rn6UTF8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </v-flex> 
                    <v-flex v-if="dialogDinamico.conquistaRegra">
                        <v-carousel v-model="conquistaRegraCarousel" :continuous="false" :hide-delimiter-background="true" :show-arrows-on-hover="false" delimiter-icon="mdi-circle" prev-icon="mdi-arrow-left" next-icon="mdi-arrow-right" style="height:400px;">
                            <v-carousel-item v-for="(item, i) in conquistaRegraLista" :key="i">
                                <v-sheet color="white">
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <img style="padding:0px;" :src="`/upload/sou_mais/${item.imagem}`" :max-width="item.imagemWidth" :max-height="item.imagemHeight" /><br />
                                        </v-col>                              
                                    </v-row>    
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="10">
                                            <strong style='color:#1FA9E1;font-size:50px;'>{{ item.titulo }}</strong>
                                            <div style="height:100px;font-size:18px; line-height:30px; color:black;" v-if="!item.ultimo" v-html="item.texto"></div>                                        
                                        </v-col>                                        
                                    </v-row>
                                    <v-row dense align="center" justify="center">
                                        <v-col cols="12">
                                            <v-btn v-if="item.ultimo" @click="marcarConquistaRegraLida()" color="#1FA9E1" rounded large outlined><strong style="font-size:18px;">Continuar</strong></v-btn>
                                        </v-col>                                        
                                    </v-row>                                                                    
                                </v-sheet>                                                               
                            </v-carousel-item>
                        </v-carousel>
                    </v-flex>

                    <v-flex v-if="dialogDinamico.conquistaInfo">
                        <v-row dense v-for="(item, i) in conquistas" :key="i">
                            <v-col cols="12">
                                <v-card align-self-center>
                                    <div class="d-flex flex-no-wrap">
                                        <v-avatar align-self-center size="80">
                                            <!-- <v-img v-if="!item.Conquistado" src="/upload/sou_mais/achievement_default.png"></v-img> -->
                                            <v-img :class="!item.Conquistado ? `imagem-borrada` : ``"  :src="`data:image/png;base64,${item.Conquista.Icone.base64}`"></v-img>
                                        </v-avatar>
                                        <div style="width:100%;">
                                            <v-card-title style="line-height: 0;word-break: break-word !important;" class="justify-start" v-text="item.Conquista.Nome"></v-card-title>
                                            <v-card-text style="text-align:left;" class="justify-start" v-text="item.Conquistado ? item.Conquista.DesbloqueioTitulo : item.Conquista.Descricao"></v-card-text>
                                            <v-card-actions class="justify-end">
                                                <v-spacer></v-spacer>
                                                <v-flex style="text-align:right;" v-text="item.Conquistado ? FormatarData(item.DataInclusao) : 'bloqueada'"></v-flex>
                                            </v-card-actions>
                                        </div>   
                                    </div>
                                </v-card>                                
                            </v-col>
                        </v-row>                       
                    </v-flex>

                    <v-flex v-if="dialogDinamico.ajudaTudo">
                        <v-layout row v-for="(item, i) in ajudaTopicos" :key="i"  style="padding:4px 0px;">
                            <v-flex md12 style="text-align:justify;">
                                <strong>{{ item.questao }}</strong><br />
                                <v-flex v-html="item.resposta"></v-flex>
                            </v-flex>                                    
                        </v-layout>  
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn v-if="dialogDinamico.ajudaTudo && dialogDinamico.persistir" @click="verificaCampanhaRegraLida" color="primary"><v-icon>mdi-check</v-icon> Ok</v-btn>
                    <v-btn v-if="dialogDinamico.botaoFechar" @click="dialogDinamico.mostrar = false;" color="primary"><v-icon>mdi-check</v-icon> Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>  
        <!-- CORPO -->
        <v-row dense  style="width: 100%;">
            <!--COLUNA 1 -->
            <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                <v-row dense style="width:100%;">
                    <v-col cols="12">
                        <!-- CARD VERDE -->                           
                        <v-tooltip bottom align="center">
                            <template v-slot:activator="{ on, attrs }"> 
                                <v-card v-bind="attrs" v-on="on" color="#1ED349" class="pa-2 rounded-xl" style="text-align:center;color:white;height:220px;cursor:pointer;">
                                    <v-row dense style="height: 120px;">
                                        <v-col cols="12">
                                            <span v-if="renovacao.minimoPorcentagem > renovacao.progresso" style="font-size:14px;">Atinja no mínimo {{ renovacao.minimoPorcentagem }}% em renovações</span>
                                            <span v-if="renovacao.progresso >= renovacao.minimoPorcentagem" style="font-size:13px;">
                                                <strong style="font-size:25px;">Seu objetivo foi concluído</strong><br />
                                                Você está habilitado para a próxima fase, <br />
                                                mas que tal alcançar 100%?
                                                </span> 
                                            <br /><br />
                                            <v-progress-linear :value="renovacao.progresso" color="#26AE80" background-color="#EDEDF6" height="18" class="rounded-xl">
                                                <template>
                                                    <!-- v-slot:default="{ value }" <strong style="color:#777; display:none;">{{ Math.ceil(value) }}%</strong> -->
                                                    <strong :style="`color:#26AE80; font-size:26px;padding-left:${renovacao.minimoPorcentagem-15}%`">|</strong>
                                                    <!-- <v-icon large color="red" :style="`font-size:26px;padding-top: 5%;padding-left:${renovacao.minimoPorcentagem-15}%`">mdi-menu-up</v-icon> -->
                                                </template>
                                            </v-progress-linear>
                                            
                                            <span style="line-height:10px;"><br /></span>
                                            <span v-if="renovacao.minimoPorcentagem > renovacao.progresso" style="font-size:25px;">R$ <strong>{{ $parent.formatPrice(renovacao.minimoPorcentagemValor, 2) }}</strong></span>
                                        </v-col>
                                    </v-row>
                                    <v-row dense style="width:100%">
                                        <v-col>
                                            <div class="line"></div>
                                        </v-col>
                                    </v-row>                            
                                    <v-row>
                                        <v-col cols="6" sm="6" md="6">
                                            <span style="font-size:13px;">Faltam para seu objetivo</span><br />
                                            <span style="font-size:19px;">R$ <strong>{{ $parent.formatPrice(renovacao.valorFaltante, 2) }}</strong></span>
                                        </v-col>
                                        <v-col cols="6" sm="6" md="6">
                                            <span style="font-size:13px;">Você já renovou</span><br />
                                            <span style="font-size:19px;">R$ <strong>{{ $parent.formatPrice(renovacao.valorAtual, 2) }}</strong></span>                                    
                                        </v-col>                                
                                    </v-row>                               
                                </v-card>
                            </template>
                            <span>
                                Este objetivo é calculado com base na sua produção em 2020. Em caso de dúvidas, consulte o regulamento.
                            </span>
                        </v-tooltip>                                                    
                    </v-col>
                </v-row>
                <v-row dense  style="width:100%;">
                    <v-col cols="12">
                        <!-- CARD INFO CAMPANHA -->
                        <v-card color="#F8FDFF" class="pa-2 rounded-xl" elevation="5" style="text-align:center;">
                            <v-card-title style="color:#F57E27;font-size:15px; text-align:center; word-break: break-word !important;"  align-self-center>
                                INFORMAÇÕES SOBRE A CAMPANHA
                                <div class="line" style="border-bottom: 1px solid #F57E27;"></div> <br />
                            </v-card-title>
                            <v-card-text>
                                <v-row dense v-for="(item, i) in campanhaInfo.slice(0,6)" :key="i">
                                    <v-col cols="2">
                                        <v-icon v-text="item.icone" color="#F57E27"> </v-icon>
                                    </v-col>
                                    <v-col cols="10" style="text-align:justify;">
                                        <v-flex class="box-with-link" v-html="item.texto"></v-flex>
                                    </v-col>                                    
                                </v-row>
                            </v-card-text>
                            <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#1FA9E1" @click="campanhaInfoTudoDialog()" text>Ver todas</v-btn>
                            </v-card-actions> -->
                        </v-card>                        
                    </v-col>
                </v-row>  
                <v-row dense style="width:100%;">
                    <v-col cols="12">
                        <v-flex class="avisoAtualizacao">
                            <span v-show="false">* Os valores mostrados no painel foram atualizados há {{ horaAtualizacao }} hora(s).</span>
                            * Os valores mostrados no painel estão atualizados até {{ horaAtualizacao }}
                        </v-flex>                                            
                    </v-col>
                </v-row>           
            </v-col>
            <!--COLUNA 2 -->
            <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                <v-row dense style="width:100%;">
                    <v-col cols="12">
                        <!-- CARD AZUL -->
                        <v-tooltip bottom align="center">
                            <template v-slot:activator="{ on, attrs }"> 
                                <v-card  v-bind="attrs" v-on="on" class="pa-2 rounded-xl" color="#1FA9E1" style="color:white; text-align:center; height:220px;">
                                    <v-row dense style="height: 120px;">
                                        <v-col cols="4">
                                            <v-progress-circular :rotate="-90" size="95" width="15" :value="venda.valorPorcentagem" color="#5CD8FE">
                                                <span style="color: white !important;">{{ $parent.formatPrice(venda.valorPorcentagem, 2) }}%</span>
                                            </v-progress-circular>
                                        </v-col>
                                        <v-col cols="8" style="line-height:24px;">
                                            <v-flex v-if="venda.valorPorcentagem < 100" style="padding:6% 5%;text-align:left;font-size:14px;">
                                                Objetivo em vendas novas<br />
                                                <span style="font-size:25px;">R$ <strong>{{ $parent.formatPrice(venda.objetivo) }}</strong></span><br />                               
                                            </v-flex>
                                            <v-flex  v-if="venda.valorPorcentagem >= 100" style="padding:6% 5%;text-align:left;font-size:13px;">
                                                <span style="font-size:25px;"><strong>Seu objetivo foi concluído</strong></span>
                                                <br />
                                                Parabéns! Você está habilitado para a próxima fase.
                                            </v-flex>                                                 

                                        </v-col>                                
                                    </v-row>  
                                    <v-row dense style="width:100%">
                                        <v-col>
                                            <div class="line"></div>
                                        </v-col>
                                    </v-row>                          
                                    <v-row dense style="width:100%">
                                        <v-col cols="6">
                                            <span style="font-size:13px;">Faltam para seu objetivo</span><br />
                                            <span style="font-size:20px;">R$ <strong>{{ $parent.formatPrice(venda.valorFaltante, 2) }}</strong></span>
                                        </v-col>
                                        <v-col cols="6">
                                            <span style="font-size:13px;">Você já vendeu</span><br />
                                            <span style="font-size:20px;">R$ <strong>{{ $parent.formatPrice(venda.valorAtual, 2) }}</strong></span>                                    
                                        </v-col>                                
                                    </v-row>
                                </v-card>   
                            </template>
                            <span>
                                Este objetivo é calculado com base na sua produção em 2020. Em caso de dúvidas, consulte o regulamento.
                            </span>
                        </v-tooltip>                           
                    </v-col>
                </v-row>
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <!-- RESUMO DO MÊS -->
                        <v-card color="#F8FDFF" class="pa-2 rounded-xl" elevation="5" style="text-align:center;">
                            <v-card-title style="color:#1FA9E1;font-size:15px; text-align:center;word-break: break-word !important;"  align-self-center>
                                RESUMO DO MÊS
                                <div class="line" style="border-bottom: 1px solid #1FA9E1;"></div> <br />
                            </v-card-title>
                            <v-card-text>
                                <v-flex style="text-align: left;line-height: 30px; border-left: 6px solid #FFB800;padding-left:6px;">
                                    <strong>No último mês você atingiu</strong><br />
                                    <strong style="color:#1FA9E1;font-size:34px;">R$ {{ $parent.formatPrice(resumoMes.valor, 2) }} </strong><br />
                                    <strong>em vendas novas</strong><br />
                                    {{ resumoMes.diferencaMesAnterior }}<br />
                                    <v-row dense style="line-height: 15px;font-size:12px;">
                                        <v-col cols="1">
                                            <p>
                                                <v-icon color="#1FA9E1" dense>mdi-lightbulb-on-outline</v-icon>
                                            </p>
                                        </v-col>
                                        <v-col cols="10">
                                            <strong>Venda mais!</strong> Quanto maior for sua produção, maior pode ser sua premiação ao final da campanha.
                                        </v-col>                                        
                                    </v-row>
                                </v-flex>
                                <br /><br />
                                <v-flex style="color:#1FA9E1;font-weight: 500; text-align: left; line-height:12px;">
                                    INSIGHTS<br /><br />
                                    <div class="line" style="border-bottom: 1px solid #1FA9E1;"></div><br />
                                </v-flex>
                                <br />
                                <v-row dense style="width:100%;">
                                    <v-col cols="2" style="font-size:13px;padding:0;">
                                        <strong style="color:#1FA9E1;">Média<br />Mensal</strong>
                                    </v-col>
                                    <v-col cols="5" justify="center" style="font-size:19px;padding:5% 0%;">
                                        R$ <strong>{{ $parent.formatPrice(resumoMes.mediaMensal, 2) }}</strong>
                                    </v-col>
                                    <v-col cols="1" style="font-size:10px; line-height: 10px;padding:0;">
                                        <v-flex v-show="false">
                                            <v-icon color="green" v-if="resumoMes.mediaMensalPositiva">mdi-menu-up</v-icon> <br v-if="resumoMes.mediaMensalPositiva" />
                                            {{ resumoMes.mediaMensalPorcentagem }} %<br v-if="!resumoMes.mediaMensalPositiva" />
                                            <v-icon color="red" v-if="!resumoMes.mediaMensalPositiva">mdi-menu-down</v-icon>                                            
                                        </v-flex>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-sparkline v-show="false" :value="resumoMes.valores" color="#1FA9E1" line-width="2" smooth="10" stroke-linecap="round" :fill="false" type="trend" :auto-line-width="false" auto-draw></v-sparkline>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="2" style="padding: 5% 1%;">
                                        <v-flex justify="center" align-self-center>
                                            <v-icon color="#1FA9E1" medium>mdi-lightbulb-on-outline</v-icon>
                                        </v-flex>
                                    </v-col>
                                    <v-col cols="10" style="font-size:12px;text-align:left;"  align-self-start>
                                        Traçe sua estratégia mensal para atingir seu objetivo de vendas novas ao final da campanha.
                                    </v-col>                                      
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" style="width:100%">
                                        <v-spacer></v-spacer>
                                        <br/>
                                        <v-spacer></v-spacer>
                                        <br/>
                                        <v-spacer></v-spacer>                                        
                                    </v-col>            
                                </v-row>                                            
                            </v-card-text>
                        </v-card>                        
                    </v-col>
                </v-row>
                <!-- CARD VIDEO -->
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card class="pa-2 rounded-xl cardVideo fill-height"  @click="videoInfoDialog()" color="#fafafa" align-self-center flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col cols="12" style="width:100%">
                                        <v-spacer></v-spacer>
                                        <br/>
                                        <v-spacer></v-spacer>
                                        <br/>
                                        <v-spacer></v-spacer>                                        
                                        <br/>
                                        <v-spacer></v-spacer>                                        
                                        <br/>
                                        <v-spacer></v-spacer>
                                        <br/>
                                        <v-spacer></v-spacer>                                                                                                                                                                                                      
                                    </v-col>            
                                </v-row>                                 
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>                                
            </v-col>
            <!--COLUNA 3 -->
            <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card class="pa-2 rounded-xl" outlined :style="corretorCampanha.cardEstilo">
                            <v-row dense style="width: 100%;">
                                <v-col cols="12"></v-col>
                            </v-row>                                
                            <v-row dense style="width: 100%;">
                                <v-col cols="8">
                                    <v-badge bottom color="white" offset-x="20" offset-y="20">
                                        <template v-slot:badge>
                                            <v-icon color="black" style="cursor:pointer;" @click="uploadDialog()">mdi-camera-plus-outline</v-icon>
                                        </template>
                                        <v-avatar size="57" color="white">
                                            <v-avatar color="#bbb">
                                                <v-icon color="black" v-if="corretorCampanha.avatar == null" dark>mdi-account-circle</v-icon>
                                                <img v-if="corretorCampanha.avatar != null" :src="`data:image/png;base64,${corretorCampanha.avatar.base64}`" />
                                            </v-avatar>                                
                                        </v-avatar>
                                    </v-badge>
                                    <br /><br />
                                    <v-flex style="color:white; font-size: 16px;">{{ this.$parent.corretorNome }}</v-flex>                                          
                                </v-col>
                                <v-col cols="4" style="text-align:center; align-items: center;">
                                    <br />
                                    <v-flex v-show="false">
                                        <img :src="`/upload/sou_mais/${corretorCampanha.nivel}.png`" style="width:50px;height:50px;" />
                                        <v-flex style="color:white; font-size: 12px;">Nível {{ corretorCampanha.nivelNome }}</v-flex>     
                                    </v-flex>
                                </v-col>
                            </v-row>
                            <v-row dense style="width: 100%;">
                                <v-col cols="12"></v-col>
                            </v-row>          
                            <v-row dense style="width: 100%;">
                                <v-col cols="12"><br /></v-col>
                            </v-row>                                                   
                            <v-row dense style="width: 100%;">
                                <v-col cols="12" style="color:#7F838C;">
                                    <strong>SUAS CONQUISTAS</strong><br />
                                    Cumpra tarefas importantes e obtenha suas conquistas  
                                    <br /><br />                                  
                                </v-col>
                            </v-row>
                            <v-row dense style="width: 100%;">
                                <v-col xs="12" sm="12" md="3" lg="3" xl="3" v-for="(item, i) in conquistas.slice(0,8)" :key="i" style="text-align:center;">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-flex v-bind="attrs" v-on="on">
                                                <v-avatar size="62">
                                                    <!-- <v-img v-if="!item.Conquistado" src="/upload/sou_mais/achievement_default.png"></v-img> -->
                                                    <v-img :class="!item.Conquistado ? `imagem-borrada` : ``"  :src="`data:image/png;base64,${item.Conquista.Icone.base64}`"></v-img>
                                                </v-avatar>
                                                <v-flex v-if="!item.Conquistado" style="color:#A6ACBE; font-size:11px;">{{ item.Conquista.Nome }}</v-flex>
                                                <v-flex v-if="item.Conquistado" style="color:black; font-size:11px;">{{ item.Conquista.Nome }}</v-flex>  
                                            </v-flex>
                                        </template>
                                        <span>
                                            {{ item.Conquistado ? item.Conquista.DesbloqueioTitulo : item.Conquista.Descricao }}
                                        </span>                                           
                                    </v-tooltip>                                                            
                                </v-col>   
                            </v-row>  
                            <v-row dense style="width: 100%;">
                                <v-col cols="6"></v-col>
                                <v-col cols="6" style="text-align:right;">
                                    <v-spacer></v-spacer>
                                    <v-btn color="#1FA9E1" @click="conquistaInfoDialog()" text class="btn-texto">Ver todas</v-btn>                                      
                                </v-col>                              
                            </v-row>                                                         
                        </v-card>
                    </v-col>
                </v-row>  
                <v-row dense style="width: 100%;">
                    <v-col cols="12">
                        <v-card class="pa-2" style="text-align:center;color:#7F838C;word-break: break-word !important;" color="#fafafa" align-self-center flat>
                            <v-card-title style="word-break: break-word !important;">
                                PRECISA DE AJUDA?
                                <div class="line" style="border-bottom: 1px solid #7F838C;"></div> <br />
                            </v-card-title>  
                            <v-card-text>
                                <v-tooltip bottom v-for="(item, i) in ajudaTopicos.slice(0,5)" :key="i">>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-row dense v-bind="attrs" v-on="on">
                                            <v-col cols="1" align="center" justify="center">
                                                <v-icon color="#7F838C" @click="ajudaTopicoDialog(item)">mdi-chevron-right-circle-outline</v-icon>
                                            </v-col>
                                            <v-col cols="10" align="left" justify="center">
                                                <v-btn color="#1FA9E1" @click="ajudaTopicoDialog(item)" text>
                                                    <div style="white-space:nowrap;width:250px;overflow-x:hidden;text-overflow:ellipsis;text-decoration:underline;">
                                                        {{ item.questao }}
                                                    </div>
                                                </v-btn> 
                                            </v-col>
                                        </v-row>                                          
                                    </template>
                                    <span>
                                        {{ item.questao }}
                                    </span>                                    
                                </v-tooltip>

                                <!-- <v-row dense v-for="(item, i) in ajudaTopicos.slice(0,5)" :key="i">
                                    <v-col cols="1">
                                        <v-icon color="#7F838C" @click="ajudaTopicoDialog(item)" class="hover">mdi-chevron-right-circle-outline</v-icon>
                                    </v-col>
                                    <v-col cols="10" style="text-align:justify;">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-flex v-bind="attrs" v-on="on">
                                                    <v-btn color="#1FA9E1" @click="ajudaTopicoDialog(item)" text>
                                                        <div style="white-space:nowrap;width:250px;overflow-x:hidden;text-overflow:ellipsis;text-decoration:underline;">
                                                            {{ item.questao }}
                                                        </div>
                                                    </v-btn> 
                                                </v-flex>
                                            </template>
                                            <span>
                                                {{ item.questao }}
                                            </span>                                    
                                        </v-tooltip>
                                    </v-col>
                                </v-row>                     -->
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#1FA9E1" @click="ajudaTudoDialog(false)" text outlined rounded>
                                    <strong class="link">Ver todos os tópicos</strong>
                                    <v-icon>mdi-arrow-right</v-icon>
                                </v-btn>
                            </v-card-actions>                                                      
                        </v-card>
                    </v-col>
                </v-row>                              
            </v-col>                        
        </v-row>
    </v-container>
</template>
<script>
    import Vue from 'vue';
    import Helpers from "@/utilities/Helpers";
    import { mapState, mapGetters } from "vuex";
    import SouMaisPrevisul from '@/assets/jsonStore/SouMaisPrevisul.json';
    import myUpload from 'vue-image-crop-upload'; 

export default {
    mixins: [Helpers],
    components:{ 'my-upload': myUpload },
    data () {
        return {
            campanhaRegraLista: SouMaisPrevisul.CampanhaRegras,
            renovacao : {
                progresso: 0,
                minimoPorcentagem: 85,
                valorAtual: 0,
                valorFaltante: 0,
                minimoPorcentagemValor: 0,
            },
            venda: {
                valorPorcentagem: 0,
                objetivo: 0,
                valorFaltante: 0,
                valorAtual: 0 
            },
            conquistaRegraLista: SouMaisPrevisul.ConquistaRegras,
            campanhaInfo: SouMaisPrevisul.CampanhaInfo,
            campanhaRegraCarousel: 0,
            conquistaRegraCarousel: 0,
            dialogDinamico: 
            {
                width: 750,
                persistir: false,
                mostrar: false,
                titulo: "",
                subTitulo: "",
                conteudo: "",
                conteudoDinamico: false,
                campanhaRegra: false,
                campanhaInfo: false,
                videoInfo: false,
                conquistaRegra: false,
                conquistaInfo: false,
                ajudaTudo: false,
                botaoFechar: false
            },
            horaAtualizacao: '3',
            resumoMes: {
                valor: 6120.23,
                diferencaMesAnterior: "9% a menos que o período anterior",
                mediaMensal: 40019.29,
                mediaMensalPorcentagem: 16,
                mediaMensalPositiva: true,
                valores: [0, 2, 5, 9, 5, 10, 3, 5, 1, 9]
            },
            corretorCampanha: {
                Id: 0,
                avatar: null,
                nivel: "",
                nivelNome: "",
                cardEstilo : "background: linear-gradient(to top, white 0%,white 5%,#727272 10%,#727272 60%);",
                campanhaRegraLida: false,
                conquistaRegraLida: false,
            },
            corretorNome: "",
            conquistas : [], //SouMaisPrevisul.Conquistas,
            ajudaTopicos : SouMaisPrevisul.Ajuda,
            uploadShow: false,
            imgDataUrl: '',
            uploadParams : {
                token: '12345678',
                avatar: 'avatar'
            },
            uploadHeaders : {
                smail : '*_~'
            },
            notificarConquista: null,
        }
      
    },
    methods: {
        campanhaInfoAcao(id, alertaId)
        {

            console.log(`id : ${id} alertaId : ${alertaId}`);
            this.resetarDialogDinamico();

            let _campanhaInfo = this.campanhaInfo.find((item) => item.id == id);                
            let _alerta = _campanhaInfo.alertas.find((item) => item.id == alertaId);

            this.dialogDinamico.titulo = _alerta.titulo;
            this.dialogDinamico.conteudo = _alerta.conteudo;
            this.dialogDinamico.conteudoDinamico = true;
            this.dialogDinamico.botaoFechar = true;
            this.dialogDinamico.mostrar = true;
        },
        campanhaInfoTudoDialog()
        {
            this.resetarDialogDinamico();
            this.dialogDinamico.campanhaInfo = true;
            this.dialogDinamico.titulo = "<div class='dialog-titulo'>Últimas Atualizações</div>";
            this.dialogDinamico.botaoFechar = true;
            this.dialogDinamico.mostrar = true;
        },
        videoInfoDialog()
        {
            this.dialogDinamico.videoInfo = true;
            this.dialogDinamico.titulo = "<div class='dialog-titulo'>Entenda como funciona</div>"
            this.dialogDinamico.botaoFechar = true;
            this.dialogDinamico.mostrar = true;                
        },
        conquistaInfoDialog()
        {
            if(this.corretorCampanha.conquistaRegraLida)
            {
                this.dialogDinamico.conquistaInfo = true;
                this.dialogDinamico.titulo = "<div class='dialog-titulo'>Conquistas</div>"
                this.dialogDinamico.subTitulo = "Continue vendendo e acompanhe seu progresso com as conquistas desbloqueadas";
                this.dialogDinamico.botaoFechar = true;
                this.dialogDinamico.mostrar = true;
            }
            else
            {
                this.dialogDinamico.persistir = true;
                this.dialogDinamico.conquistaRegra = true;
                this.dialogDinamico.mostrar = true;
            }
        }, 
        marcarConquistaRegraLida()
        {
            let url = "SouMaisPrevisul/corretor/conquista-regra-lida/"+ this.corretorCampanha.Id;                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.put(url)
            .then(res => {
                this.corretorCampanha.conquistaRegraLida = res.data;
                this.resetarDialogDinamico();
                this.dialogDinamico.mostrar = false; 
                this.conquistaInfoDialog();
                this.$parent.fullLoading = false;           
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });                   

        },
        ajudaTopicoDialog(topico)
        {
                this.dialogDinamico.titulo = `<div class='dialog-titulo'>${topico.questao}</div>`;
                this.dialogDinamico.conteudo = topico.resposta;
                this.dialogDinamico.conteudoDinamico = true;
                this.dialogDinamico.botaoFechar = true;
                this.dialogDinamico.mostrar = true;                
        },
        regulamentoDialog()
        {
            this.$parent.regulamentoAssinado = true;
            this.$parent.campanhaRegulamento = 1;
            this.$parent.dialogRegulamento = true;  
        },        
        ajudaTudoDialog(persistir)
        {
                this.resetarDialogDinamico();

                this.dialogDinamico.campanhaRegra = false;
                this.dialogDinamico.persistir = persistir;        
                this.dialogDinamico.titulo = `<div class='dialog-titulo'>Precisa de ajuda?</div>`;
                this.dialogDinamico.subTitulo = `<div class='dialog-sub-titulo'>Entenda como funciona a campanha e seu dashboard</div>`;
                this.dialogDinamico.ajudaTudo = true;
                this.dialogDinamico.conteudoDinamico = true;
                this.dialogDinamico.botaoFechar = !persistir;
                this.dialogDinamico.mostrar = true;    
        },
        cropSuccess(imgDataUrl, field)
        {
            let _avatar = { Id : this.corretorCampanha.Id, AvatarBase64: imgDataUrl.replace('data:image/png;base64,', '') };

            let url = 'SouMaisPrevisul/corretor/avatar';                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.post(url, _avatar)
            .then(res => {
                this.uploadShow = false;
                this.$parent.fullLoading = false;
                if (res.data == true)
                    this.carregarDados();                
                else
                {
                    this.showToast("error", "Erro", "Ocorreu um problema no carregamento");   
                }
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });              
        },
        cropUploadSuccess(jsonData, field)
        {
            console.log("cropUploadSuccess");
            console.log(jsonData);
            console.log('field '+ field);
        },
        cropUploadFail(status, field)
        {
            console.log("cropUploadFail");
            console.log(status);
            console.log('field '+ field);                
        },
        verificaCampanhaRegraLida()
        {
            if(!this.corretorCampanha.campanhaRegraLida)
            {
                this.resetarDialogDinamico();
                this.dialogDinamico.persistir = true;
                this.dialogDinamico.campanhaRegra = true;
                this.dialogDinamico.mostrar = true;                    
            }else
            {
                this.verificarConquistaNotificada();
            }
        },
        marcarCampanhaRegraLida()
        { 
            let url = "SouMaisPrevisul/corretor/campanha-regra-lida/"+ this.corretorCampanha.Id;                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.put(url)
            .then(res => {
            console.log(url);    
            console.log(res.data);
            this.corretorCampanha.campanhaRegraLida = res.data;
            this.resetarDialogDinamico();
            this.dialogDinamico.mostrar = false; 
            this.$parent.fullLoading = false;
            this.verificarConquistaNotificada();
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });                  
        }, 
        resetarDialogDinamico()
        {
            this.dialogDinamico.persistir = false;
            this.dialogDinamico.width = 750;
            this.dialogDinamico.titulo = "";
            this.dialogDinamico.subTitulo = "";
            this.dialogDinamico.conteudo = "";
            this.dialogDinamico.campanhaRegra = false;
            this.dialogDinamico.campanhaInfo = false;
            this.dialogDinamico.conteudoDinamico = false;
            this.dialogDinamico.videoInfo = false;
            this.dialogDinamico.conquistaRegra = false;
            this.dialogDinamico.conquistaInfo = false;
            this.dialogDinamico.ajudaTudo = false;
            this.dialogDinamico.botaoFechar = false;
        },
        carregarDados()
        {
            let codigoCorretor = this.usuario.codCorretor;
            let url = "SouMaisPrevisul/corretor/"+ codigoCorretor;                
            
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.get(url)
            .then(res => {
            this.corretorCampanha.Id = res.data.Id;
            this.corretorCampanha.avatar =  res.data.Avatar != null ? res.data.Avatar : null;
            this.corretorCampanha.nivel = res.data.Nivel;
            this.corretorCampanha.nivelNome = res.data.NivelNome;
            this.corretorCampanha.campanhaRegraLida = res.data.CampanhaRegraLida;
            this.corretorCampanha.conquistaRegraLida = res.data.ConquistaRegraLida;
            this.conquistas = res.data.Conquistas;
            res.data.TotalizacaoMeta;

            this.renovacao = {
                progresso: res.data.TotalizacaoMeta.valorPercentualAtingidoRenovacao,
                minimoPorcentagem: 85,
                valorAtual: res.data.TotalizacaoMeta.valorRenovacaoAtual,
                valorFaltante: res.data.TotalizacaoMeta.valorFaltaMetaRenovacao,
                minimoPorcentagemValor: res.data.TotalizacaoMeta.valorMetaRenovacao,
            };
            this.venda = {
                valorPorcentagem: res.data.TotalizacaoMeta.valorPercentualAtingidoVendaNova,
                objetivo: res.data.TotalizacaoMeta.valorMetaVendaNova,
                valorFaltante: res.data.TotalizacaoMeta.valorFaltaMetaVendaNova,
                valorAtual: res.data.TotalizacaoMeta.valorVendaNovaAtual
            };

            this.resumoMes = {
                valor: res.data.TotalizacaoMensal.valorVendaNovaAtual,
                diferencaMesAnterior: res.data.TotalizacaoMensal.diferencaMesAnterior,
                mediaMensal: res.data.TotalizacaoMeta.valorMediaVendaNova,
                mediaMensalPorcentagem: 16,
                mediaMensalPositiva: true,
                valores: [0, 2, 5, 9, 5, 10, 3, 5, 1, 9]
            };         
            
            this.horaAtualizacao = res.data.AtualizacaoMesAno;

            let _percentGradient = "72";
            if(this.conquistas.length < 5)
                _percentGradient = "65";

            this.corretorCampanha.nivel = 'DiamanteAzul';

            switch (this.corretorCampanha.nivel) {
            case 'Cristal':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#727272 10%,#727272 50%);`;
                break;
            case 'Topazio':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#E6843F 10%,#E6843F 50%);`;
                break;
            case 'Esmeralda':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#64CF5C 10%,#64CF5C 50%);`;
                break;     
            case 'Safira':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#1D3F65 10%,#1D3F65 50%);`;
                break;       
            case 'DiamanteAzul':
                this.corretorCampanha.cardEstilo = `background: linear-gradient(to top, white 40%,white ${_percentGradient}%,#50A7DC 10%,#50A7DC 50%);`;
                break;                                                        
            default:
                console.log(`Sorry, we are out of.`);
            }            

            this.verificaCampanhaRegraLida();
            this.$parent.fullLoading = false;
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });                
        },
        verificarConquistaNotificada()
        {
            let _corretorId = this.corretorCampanha.Id;
            console.log("verificarConquistaNotificada");
            console.log(this.conquistas);     
            
            let _conquista = this.conquistas.find((item) => item.Conquistado == true && item.Notificado == false);

            console.log("find > conquista");
            console.log(_conquista);
            if(_conquista != undefined)
            {
                this.resetarDialogDinamico();
                this.notificarConquista = _conquista;
            }           
        },
        marcarConquistaNotificada(id)
        {
            let url = "SouMaisPrevisul/corretor/conquista-notificada/"+ id;                
            this.$parent.fullLoading = true;

            Vue.prototype.$httpPortal.put(url)
            .then(res => {
            console.log(url);    
            console.log(res.data);

            for (let index in this.conquistas)
            {
                if (this.conquistas[index].Id == id)
                {
                    this.conquistas[index].Notificado = res.data;
                }
            }

            this.notificarConquista = null;
            this.$parent.fullLoading = false;
            this.carregarDados();
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.$parent.fullLoading = false;
            });             
        },
        uploadDialog()
        {  
            this.uploadShow = !this.uploadShow;               
        },                             
    },
    created(){
        window.campanhaInfoAcao = this.campanhaInfoAcao.bind(this);
        window.regulamentoDialog = this.regulamentoDialog.bind(this);

        let _corretorNomeArray = this.usuario.nome.trim().split(' ');
        if (_corretorNomeArray[0] !== undefined)
        {
            this.corretorNome = _corretorNomeArray[0];
        }
        if (_corretorNomeArray[1] !== undefined)
        {
            this.corretorNome += ' '+ _corretorNomeArray[1];
        }
        
        if(this.corretorNome.length == 0)
        {
            this.corretorNome = "Corretor";
        }
        
    },
    computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
    },
    watch: {
        "dialogDinamico.mostrar"() {
            if(this.dialogDinamico.mostrar == false)
            {
                this.resetarDialogDinamico();
            }
        },
    },     
    mounted()
    {
        this.carregarDados();
    }
  }
</script>
<style lang="scss">
.v-progress-circular__underlay {
    stroke: white !important;
    z-index: 1;
}

.tabelaSimples, .tabelaSimples th, .tabelaSimples td {
  border: 1px solid black;
}

.participacao-resultado-container {
    font-size:13px; 
    text-align:justify;
    // line-height: 15px;
    padding-left: 5PX;
    word-break: break-word !important;
}

.tabelaSimples {
    width:100%;
    border: 1px solid black;
    border-collapse: separate;
    border-radius:6px;
    -moz-border-radius:6px;  
}

.avisoAtualizacao {
    font-family: Roboto;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    align-items: center;
    letter-spacing: 0.01em;
    color: #7F838C;
}

.cardVideo {
    //padding: 20px; 
    // margin: 10px; 
    // height: 130px; 
    background: url('/upload/sou_mais/video_campanha.png') center center; 
    background-repeat: no-repeat; 
    background-size: contain;
    cursor: pointer;    
}
</style>